import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

class FullscreenLoader extends Component {
  static propTypes = {
    Show: PropTypes.bool.isRequired,
    Copy: PropTypes.array,
  }

  static defaultProps = {
    Copy: ['Loading'],
  }

  showCopy() {
    const { Copy } = this.props

    const longOptions = Copy.concat(Copy).concat(Copy)

    const messages = []

    for (let i = 0; i < Copy.length; i++) {
      messages.push(
        longOptions[Copy.length - 1] // 3 - 1 = 2
      )
      messages.push(
        longOptions[Copy.length] // 3 = 3
      )
      messages.push(
        longOptions[Copy.length + 1] // 3 + 1 = 4
      )
    }

    const template = [
      <div key='0' className='message item_1'>{messages[0]}</div>,
      <div key='1' className='message item_2'>{messages[1]}</div>,
      <div key='2' className='message item_3'>{messages[2]}</div>,
    ]

    return template
  }


  renderLoader() {
    const { Show } = this.props
    const loaderState = Show ? 'loader-show' : 'loader-hide'

    return (
      <section id='FULLSCREEN_LOADER' className={ `loader ${ loaderState }` }>
        <div>
          <div>
            <div id='COPY'>
              { this.showCopy() }
            </div>
            <div id='SPINNER'>
              <div className='loader'>
                <span />
                <span />
                <span />
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }

  render() {
    return (
      this.renderLoader()
    )
  }
}

export default FullscreenLoader



// WEBPACK FOOTER //
// ./src/components/Loader/index.jsx